import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-required-total-percentage",
  templateUrl: "./field-set-required-total-percentage.component.html",
})
export class FieldSetRequiredTotalPercentageComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
